import { apiCall } from './gqlClient';
const ALIGNCODA_QUERY = "\n  mutation alignCoda($providerId: Int!) {\n    alignCoda(providerId: $providerId)\n    {\n      success\n\t\t\tmessage\n\t\t\tid\n\t\t\tid2\n\t\t\tname\n\t\t\tstatus\n      ...fragments\n    }\n  }";
export const alignCodaApiCall = async function (_ref) {
  let {
    providerId
  } = _ref;
  let fragments = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return apiCall({
    query: ALIGNCODA_QUERY,
    variables: {
      providerId
    },
    fragments
  });
};